/**
 * Extracts a named property from XML content.
 * @param xml The xml content.
 * @param propertyName The name of the property to extract.
 */
export function extractPropertyFromXml(xml: string = "", propertyName: string): string {
	const xmlToLower = xml.toLowerCase();
	const propertyNameToLower = propertyName.toLowerCase();

	const propertyStartTag = `<${propertyNameToLower}>`;
	const propertyEndTag = `</${propertyNameToLower}>`;

	return xml.substring(
		xmlToLower.indexOf(propertyStartTag) + propertyStartTag.length,
		xmlToLower.indexOf(propertyEndTag)
	);
}

/**
 * Extracts a named property from XML content - return "" if not found
 * @param xml The xml content.
 * @param propertyName The name of the property to extract.
 */
export function extractPropertyFromXmlWithContainsCheck(xml: string = "", propertyName: string): string {
	const xmlToLower = xml.toLowerCase();
	const propertyNameToLower = propertyName.toLowerCase();
	if (xmlToLower.includes(propertyNameToLower)) {
		const propertyStartTag = `<${propertyNameToLower}>`;
		const propertyEndTag = `</${propertyNameToLower}>`;
		return xml.substring(
			xmlToLower.indexOf(propertyStartTag) + propertyStartTag.length,
			xmlToLower.indexOf(propertyEndTag)
		);
	}
	return "";
}

/**
 * Formats a region url, appending /api if necessary.
 * @param regionUrl The url to format.
 */
export function formatRegionUrl(regionUrl: string): string {
	if (!regionUrl) {
		return null;
	}

	let url = regionUrl.toLowerCase();

	if (
		!url.endsWith("/api/") &&
		!url.endsWith("/api") &&
		!url.startsWith("http://local.sureviewsystems.com") &&
		!url.startsWith("https://local.sureviewsystems.com")
	) {
		url = `${url}/api`;
	}

	return url;
}
